export const ListingsEmptyStateIllustration = () => (
  <svg
    fill='none'
    height='106'
    viewBox='0 0 107 106'
    width='107'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <linearGradient id='a'>
      <stop offset='0' stopColor='#c4c4c4' />
      <stop offset='1' stopColor='#717171' stopOpacity='.38' />
    </linearGradient>
    <linearGradient id='b' gradientUnits='userSpaceOnUse' x1='53.6697' x2='53.6697' xlinkHref='#a' y1='0' y2='106' />
    <linearGradient id='c'>
      <stop offset='0' stopColor='#fff' stopOpacity='.43' />
      <stop offset='1' stopColor='#252121' stopOpacity='.04' />
    </linearGradient>
    <linearGradient id='d' gradientUnits='userSpaceOnUse' x1='53.6697' x2='53.6697' xlinkHref='#c' y1='0' y2='106' />
    <linearGradient id='e' gradientUnits='userSpaceOnUse' x1='53.6697' x2='53.6697' xlinkHref='#a' y1='9' y2='97' />
    <linearGradient id='f' gradientUnits='userSpaceOnUse' x1='53.6697' x2='53.6697' xlinkHref='#c' y1='9' y2='97' />
    <linearGradient id='g' gradientUnits='userSpaceOnUse' x1='53.6697' x2='53.6697' xlinkHref='#a' y1='18' y2='88' />
    <linearGradient id='h' gradientUnits='userSpaceOnUse' x1='53.6697' x2='53.6697' xlinkHref='#c' y1='18' y2='88' />
    <linearGradient id='i' gradientUnits='userSpaceOnUse' x1='52.8897' x2='52.8897' y1='31.3334' y2='69.3334'>
      <stop offset='0' stopColor='#f3eff1' />
      <stop offset='.140625' stopColor='#f3eff1' stopOpacity='.7825' />
      <stop offset='.3125' stopColor='#f3eff1' stopOpacity='.7825' />
      <stop offset='.692708' stopColor='#f3eff1' stopOpacity='.534715' />
      <stop offset='1' stopColor='#f3eff1' stopOpacity='.2' />
    </linearGradient>
    <g opacity='.6'>
      <circle cx='53.6697' cy='53' fill='url(#b)' opacity='.2' r='52.5' stroke='url(#d)' />
      <circle cx='53.6697' cy='53' fill='url(#e)' opacity='.2' r='43.5' stroke='url(#f)' />
      <circle cx='53.6697' cy='53' fill='url(#g)' opacity='.2' r='34.5' stroke='url(#h)' />
    </g>
    <path
      clipRule='evenodd'
      d='m76.1097 53.8534-8.7-8.44v-12.68h-5.82v7.04l-8.7-8.44-23.22 22.52v1.4h5.8v14.08h14.52v-8.44h5.8v8.44h14.52v-14.08h5.8z'
      fill='url(#i)'
      fillRule='evenodd'
      opacity='.8'
    />
  </svg>
)
